module.exports = __webpack_public_path__ + "static/media/triangle-alert.695758bf.svg";